import * as React from 'react';

import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import useBreakpoints from '../../../hooks/useBreakpoints';

type SideBySideProps = {
  ratio?: number;
  shouldFlexEnd?: boolean;
};

const SideBySide: React.FC<React.PropsWithChildren<SideBySideProps>> = ({
  children,
  ratio = 6,
  shouldFlexEnd = false,
}) => {
  // The old 600px threshold was unreachable: below 900px the dashboard is
  // replaced by the app-download gate, so this always rendered two columns —
  // even at widths where the fields inside (several have a 340px floor) no
  // longer fit side by side.
  const { isNarrow } = useBreakpoints();

  const childs = React.Children.toArray(children);

  const ratios = React.useMemo(() => {
    if (isNarrow) {
      return [12, 12];
    }

    return [ratio, 12 - ratio];
  }, [isNarrow, ratio]);

  return (
    <Box>
      <Grid container spacing={2}>
        {React.Children.map(childs, (child, i) => (
          <Grid key={i} item xs={ratios[i]} {...(shouldFlexEnd && { alignSelf: 'flex-end' })}>
            {child}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SideBySide;
